<template>
  <div class="progress chart-progress" v-loading="!init">
    <el-radio-group size="small" v-model="type" style="margin-bottom: 20px;">
      <el-radio-button label="Исполнители"></el-radio-button>
      <el-radio-button label="Объекты"></el-radio-button>
      <el-radio-button label="Раздел"></el-radio-button>
    </el-radio-group>
    <div class="chart" v-if="init">
      <div>
        <el-radio v-model="isCurrentPlan" :label="false">План всего</el-radio>
        <el-radio v-model="isCurrentPlan" :label="true">Текущий план</el-radio>
        <div>
          <el-radio v-model="isCurrentPlan" label="CUSTOM">
            <template>
              <date-picker
                @change="isCurrentPlan === 'CUSTOM' ? getAnalytics() : () => {}"
                style="max-width: 240px; margin-right: 20px; margin-top: 12px"
                :editable="false"
                ref="datePicker"
                placeholder="Фильтр по дате"
                v-model="datetimeRange"
                range
              ></date-picker>
            </template>
          </el-radio>
        </div>
      </div>
      <div style="height: 200px">
        <ProgressBar
          :isShowLabel="isCurrentPlan === true"
          :value1="Math.round(analytics.priceJobs.percentageProjectFact)"
          :value2="Math.round(analytics.priceJobs.percentageProjectPlan)"
          :label="analytics.priceJobs.percentagePlan"
        />
      </div>
      <div class="labels-custom" style="margin-left: 20px; display: flex; justify-content: center">
        <span class="strong">План: {{
            numberWithSpaces(toFixedWithoutZero(analytics.priceJobs.plan))
          }}</span>
        <span class="strong">Факт: {{
            numberWithSpaces(toFixedWithoutZero(analytics.priceJobs.fact))
          }}</span>
      </div>


      <div style="margin-bottom: 120px">
        <div style="margin-top: 40px" class="chart-container-companies" v-for="comp in companies" :key="comp.label">
          <strong class="label-chart" style="margin-bottom: 10px">{{ comp.label }}</strong>
          <div class="chart-company">
            <div class="horizontal-container">
              <horizontal-chart
                :width="250"
                :height="75"
                v-if="init"
                :chart-data="comp.data"
                :options="chartOptionsCompany">
              </horizontal-chart>
              <div class="horizontal-label" v-if="isCurrentPlan === true">
                <span
                  :style="{marginLeft: `${comp.percentageProjectPlan > 85 ? 85 : comp.percentageProjectPlan + 2}%`}">{{
                    Math.round(comp.percentageProjectPlan)
                  }}%</span>
                <span
                  :style="{marginLeft: `${comp.percentageProjectFact > 85 ? 85 : comp.percentageProjectFact + 2}%`}">{{
                    Math.round(comp.percentageProjectFact)
                  }}%</span>
              </div>

              <strong class="percent" :style="{color: pStatus(comp.percent), padding: 0, width: '70px'}">
                {{ Number(comp.percent).toFixed(0) || 0 }}%
              </strong>
            </div>
          </div>
          <div class="labels-custom">
            <div style="display: flex">
              <span class="strong">План: {{ numberWithSpaces(toFixedWithoutZero(comp.plan)) }}</span>
              <span class="strong">Факт: {{ numberWithSpaces(toFixedWithoutZero(comp.fact)) }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import firebase from "firebase";
import BarChart from "./BarChart";
import HorizontalChart from "./HorizontalChart";
import {numberWithSpaces, toFixedWithoutZero} from "../../../utils/numberUtils";
import ProgressBar from "./components/ProgressBar";
import dayjs from "dayjs";
import DatePicker from 'vue2-datepicker'
import {isApiRuleIgnore} from "../../../plugins/firebase";

export default {
  name: "Progress",
  components: {ProgressBar, HorizontalChart, BarChart, DatePicker},
  data() {
    return {
      type: 'Исполнители',
      init: false,
      isCurrentPlan: false,
      datetimeRange: [
        new Date(String(dayjs().utc().subtract(10, 'days').format('YYYY-MM-DD'))),
        new Date(String(dayjs().utc().format('YYYY-MM-DD'))),
      ],
      chartData: {
        labels: ['План', 'Факт'],
        datasets: [{
          data: [0, 0],
          barThickness: 60,
          backgroundColor: [
            'rgba(54, 162, 235, 0.2)',

            'rgba(255, 99, 132, 0.2)',
          ],
          borderColor: [
            'rgb(54, 162, 235)',

            'rgb(255, 99, 132)',
          ],
          borderWidth: 1
        }],
      },
      chartDataCompany: {
        labels: ['План', 'Факт'],
        datasets: [{
          data: [10, 22],
          barThickness: 20,
          backgroundColor: [
            'rgba(54, 162, 235, 0.2)',
            'rgba(255, 99, 132, 0.2)',
          ],
          borderColor: [
            'rgb(54, 162, 235)',
            'rgb(255, 99, 132)',
          ],
          borderWidth: 1
        }],
      },
      chartOptions: {
        minBarLength: 100,
        responsive: true,
        maintainAspectRatio: false,
        barValueSpacing: 20,
        legend: {
          display: false
        },
        scales: {
          yAxes: [{
            ticks: {min: 0},
          }],
          xAxes: [{
            display: false
          }]
        }
      },
      chartOptionsCompany: {
        minBarLength: 100,
        responsive: true,
        maintainAspectRatio: false,
        barValueSpacing: 1,
        legend: {
          display: false
        },
        scales: {
          xAxes: [{
            ticks: {min: 0},
          }],
          yAxes: [{
            display: false
          }]
        }
      },
      analytics: {
        priceJobs: {
          plan: 0,
          fact: 0,
          percentagePlan: 0,
          companies: {
            company: {
              plan: 0,
              fact: 0,
              percentagePlan: 0
            }
          }
        }
      }
    }
  },
  async mounted() {
    await this.getAnalytics();
  },
  computed: {
    companies() {
      if (!this.analytics.priceJobs || !this.analytics.priceJobs.items) {
        return []
      }

      return Object.entries(this.analytics.priceJobs.items).map(([key, obj]) => {
        return ({
          label: key,
          percent: obj.percentagePlan,
          fact: obj.fact,
          plan: obj.plan,
          percentageProjectFact: obj.percentageProjectFact,
          percentageProjectPlan: obj.percentageProjectPlan,
          percentagePlan: obj.percentagePlan,
          data: {
            labels: ['Норма', 'Факт'],
            datasets: [{
              data: [obj.percentageProjectPlan, obj.percentageProjectFact],
              barThickness: 20,
              backgroundColor: [
                'rgba(54, 162, 235, 0.2)',
                'rgba(255, 99, 132, 0.2)',
              ],
              borderColor: [
                'rgb(54, 162, 235)',
                'rgb(255, 99, 132)',
              ],
              borderWidth: 1
            }],
          }
        })
      });
    }
  },
  watch: {
    isCurrentPlan() {
      this.getAnalytics();
    },
    type() {
      this.getAnalytics(this.type === 'Объекты');
    }
  },
  methods: {
    numberWithSpaces,
    toFixedWithoutZero,
    async getAnalytics() {
      this.init = false
      let versionStorage = localStorage.getItem('version')
      if (versionStorage) {
        versionStorage = JSON.parse(versionStorage)
      }
      const version = (this.$store.state.project.version && this.$store.state.project.version.id) || (versionStorage && versionStorage.id)


      let url = `onAggregateProgressPriceJobs${version ? 'ByVersionPlan' : ''}/${this.$store.state.project.id}&queryParams=uid=${authFirestore.currentUser.uid}`

      if (version) {
        url += `, planId=${version}`
      } else if (this.$store.state.project.plan && this.$store.state.project.plan.id) {
        url += `, planId=${this.$store.state.project.plan.id}`
      }

      if (this.type === 'Объекты') {
        url += `, isObjects=true`
      }

      if (this.type === 'Раздел') {
        url += `, isDirs=true`
      }

      const dateForm = {}


      if (this.isCurrentPlan !== 'CUSTOM') {
        url += `, isCurrentPlan=${this.isCurrentPlan}`

        dateForm['isCurrentPlan'] = this.isCurrentPlan
      }

      if (this.isCurrentPlan === 'CUSTOM'  && this.datetimeRange[0]) {
        url += `, fromDate=${dayjs(this.datetimeRange[0]).format('YYYY-MM-DD')}`
        url += `, toDate=${dayjs(this.datetimeRange[1]).format('YYYY-MM-DD')}`

        dateForm['fromDate'] = dayjs(this.datetimeRange[0]).format('YYYY-MM-DD')
        dateForm['toDate'] = dayjs(this.datetimeRange[1]).format('YYYY-MM-DD')
      }

      if (isApiRuleIgnore) {
        url = url.replace('&queryParams=', '?').replace(/, /g, "&")
      }

      const proxy = firebase.functions().httpsCallable(
        url
      );
      const {data} = await proxy(
        {
          uid: authFirestore.currentUser.uid,
          planId: (this.$store.state.project.plan && this.$store.state.project.plan.id) || version || null,
          ...dateForm
        },
      );

      this.analytics.priceJobs = data.priceJobs;

      let fact = this.analytics.priceJobs.plan ? this.analytics.priceJobs.percentagePlan : 100
      let parse = [this.analytics.priceJobs.plan ? 100 : 0, fact || 0];

      if (!this.analytics.priceJobs.plan && !this.analytics.priceJobs.fact) {
        parse = [0, 0]
      }

      this.chartData.datasets[0].data = [parse[0], parse[1]]
      this.chartData.labels = [`Норма ${parse[0]}`, `Факт ${parse[1]}`];
      this.init = true
    },
    pStatus(n) {
      if (n >= 99) {
        return '#7CB342'
      }

      if (n > 70) {
        return '#F57C00'
      }

      return '#D32F2F'
    }
  }
}
</script>


<style scoped lang="scss">
.horizontal-container {
  display: flex;
}

.horizontal-label {
  display: flex;
  position: absolute;
  flex-direction: column;
  align-items: flex-start;
  padding-top: 2px;
  height: 40px;
  width: 250px;
  justify-content: space-between;

  span {
    font-size: 14px;
    font-weight: bold;
    margin-left: 100%;
  }
}

.progress {
  max-width: 600px;
  margin: 0 auto;
  // IOS ONLY REMOVE
  margin-top: -25px;

  .chart {
    margin: 0 auto;
    max-width: 400px;
    overflow: hidden;

    .percent {
      font-size: 18px;
      padding-left: 6px;
    }

    .chart-container {
      display: flex;
      align-items: center;
    }
  }
}

.chart-container-companies {
  width: 400px;
  display: flex;
  align-items: flex-start;
  padding-left: 20px;
  flex-direction: column;

  .chart-company {
    display: flex;
  }

}

.labels-custom {
  display: flex;
  align-items: flex-start;
  flex-wrap: wrap;
  flex: 1;
  width: 100%;
  text-align: center;

  span {
    color: #000;
    font-size: 13px;
    margin-top: 12px;
    margin-right: 20px;
  }
}

.strong {
  font-weight: bold;
}


.label-chart {
  text-align: left;
  white-space: pre-wrap;
  word-wrap: break-word;
  max-width: calc(100% - 60px);
}
</style>
<style lang="scss">
.chart-progress {
  .el-radio-button__inner {
    width: 100px !important;
    padding: 12px 0px !important;
  }
}
</style>




// WEBPACK FOOTER //
// src/views/Dashboard/Analytics/Progress.vue